
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CompanySearchResultViewModel extends Model<CompanySearchResultViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyName', type: 'string', languageString: 'companySearchResultView.property.companyName' },
		{ name: 'companyId', type: 'guid', languageString: 'companySearchResultView.property.companyId' },
		{ name: 'vatNumber', type: 'string', languageString: 'companySearchResultView.property.vatNumber' },
		{ name: 'hasActivePlans', type: 'boolean', languageString: 'companySearchResultView.property.hasActivePlans' },
		{ name: 'matchingProductPlanIds', type: 'string[]', languageString: 'companySearchResultView.property.matchingProductPlanIds', isArray: true },
		{ name: 'matchValues', type: 'SearchResultMatchValueModel[]', languageString: 'companySearchResultView.property.matchValues', isHidden: true, isArray: true, isObject: true, new: () => { return new SearchResultMatchValueModel }, properties: () => { return SearchResultMatchValueModel.classProperties } }
	];
	[key: string]: any;
	
	public companyName: string;
	public companyId?: string;
	public vatNumber: string;
	public hasActivePlans: boolean;
	public matchingProductPlanIds: string[];
	public matchValues: SearchResultMatchValueModel[];
    
	constructor(){
		super();
		this.companyName = '';
		this.companyId = undefined;
		this.vatNumber = '';
		this.hasActivePlans = false;
		this.matchingProductPlanIds = [];
		this.matchValues = [];
		
	}
	getProperties(){
		return CompanySearchResultViewModel.classProperties;
	}
}
export class SearchResultMatchValueModel extends Model<SearchResultMatchValueModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'type', type: 'string', languageString: 'searchResultMatchValue.property.type' },
		{ name: 'value', type: 'string', languageString: 'searchResultMatchValue.property.value' }
	];
	[key: string]: any;
	
	public type: string;
	public value: string;
    
	constructor(){
		super();
		this.type = '';
		this.value = '';
		
	}
	getProperties(){
		return SearchResultMatchValueModel.classProperties;
	}
}

